module.exports = __webpack_public_path__ + "img/productinfo-6.102b2a96.jpg";